// import ModalForm from "./Form";
import InvoiceHistoryTableForm from "./InvoiceHistoryTableForm";
import {
	INVOICE_HISTORY,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const InvoiceHistoryTableSchema = {
	components: { InvoiceHistoryTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: INVOICE_HISTORY + "?clc_id_number=" + this.value.clc_id_number,
			tableId: "invoice-history-table",
			formId: "invoice-history-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Reference ID",
					type: "custom-html",
					key: "reference_id",
					isVisible: true,
					modifier: (value) => {
						return value ? value : ''
					}
				},
				{
					title: "Request By",
					type: "custom-html",
					key: "request_user_id",
					isVisible: true,
					modifier: (value) => {
						if (value) {
							return value.full_name
						} else {
							return ""
						}
					}
				},
				{
					title: "Request Date",
					type: "text",
					key: "request_date",
				},
				{
					title: "Action",
					type: "action",
				},
                {
					title: "Invoice Request ID",
					type: "text",
					key: "request_no",
				},
				{
					title: "Invoice Status",
					type: "custom-html",
					key: "status",
					isVisible: true,
					modifier: (value) => {
						if (value) {
							let ClassName = "danger";

							if (value === "Requested")
								ClassName = `warning`;
							else if (value === "Processed")
								ClassName = `secondary`;
							else if (value === "Invoiced")
								ClassName = `primary`;
							else if (value === "Paid")
								ClassName = `success`;
							else if (value === "Cancelled" || value === "Deleted")
								ClassName = `danger`;

							return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
								value
							)}</span>`;
						}
					},
				},
				{
					title: "Completed By",
					type: "text",
					key: "completed_user_id",
				},
				{
					title: "Action",
					type: "action",
				},
				{
					title: "Fees Notice ID",
					type: "text",
					key: "invoice_no",
				},
				{
					title: "Print Date",
					type: "text",
					key: "request_print_date",
				},
                {
					title: "Due Date",
					type: "text",
					key: "due_date",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action2",
			},
			options: {
				name: "InvoiceHistoryTable",
				url: INVOICE_HISTORY + "?clc_id_number=" + this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "page",
						url: "finance/invoice-request/edit",
						target: "", // _blank to open newtab
						uniqueKey: (rowData) => rowData.id,
						disabled: (rowData) => this.isButtonDisabled(rowData)
					},
					{
						title: this.$t("view"),
						icon: "eye",
						type: "page",
						url: "finance/invoice-request/view",
						target: "",
						uniqueKey: (rowData) => rowData.id,
						disabled: (rowData) => this.isButtonDisabled(rowData)
					},
					{
						title: this.$t("Duplicate Invoice"),
						icon: "copy",
						type: "duplicate-invoice",
						disabled: (rowData) => this.isButtonDisabled(rowData)
					},
				],
				actions2: [
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
						disabled: (rowData) => this.isButtonDisabled(rowData)
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isButtonDisabled(rowData) {
			return rowData.status.toLowerCase() === "deleted";
		}
	},
};
